import React, { FC } from 'react';
import cx from 'classnames';
import MuiAlert, { AlertProps as MuiAlertProps, Color as Severity } from '@material-ui/lab/Alert';

import IconButton from 'design-system/IconButton';
import { makeStyles } from 'react-scale/components/design-system/styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type AllowedMuiAlertProps =
  | 'children'
  | 'action'
  | 'className'
  | 'classes'
  | 'closeText'
  | 'color'
  | 'icon'
  | 'onClose'
  | 'style'
  | 'severity'
  | 'variant';

export type AlertProps = Pick<MuiAlertProps, AllowedMuiAlertProps>;

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginInlineEnd: '12px',
    width: '32px',
    textAlign: 'center',
  },
  action: {
    marginInlineEnd: 0,
    paddingInlineStart: '16px',
  },
  flexContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  darkText: {
    color: theme.colors.black,
  },
}));

const severityToIcon: Record<Severity, JSX.Element> = {
  info: <FontAwesomeIcon icon="info-circle" />,
  success: <FontAwesomeIcon icon="check-circle" />,
  warning: <FontAwesomeIcon icon="exclamation-triangle" />,
  error: <FontAwesomeIcon icon="exclamation-triangle" />,
};

const Alert: FC<AlertProps> = ({ icon, action, onClose, ...props }) => {
  const { flexContent, darkText, ...classes } = useStyles();

  return (
    <MuiAlert
      classes={classes}
      className={cx({ [darkText]: props.severity === 'info' })}
      icon={icon ?? severityToIcon[props.severity!]}
      action={
        onClose ? (
          <div className={flexContent}>
            {action}
            <IconButton onClick={onClose}>
              <FontAwesomeIcon icon="times" />
            </IconButton>
          </div>
        ) : (
          action
        )
      }
      {...props}
    />
  );
};

Alert.defaultProps = {
  severity: 'info',
};

export default Alert;
